import { render } from "./AddUserExperienceModal.vue?vue&type=template&id=385364ee&ts=true"
import script from "./AddUserExperienceModal.vue?vue&type=script&lang=ts"
export * from "./AddUserExperienceModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__